import { useAppContext } from "../../../AppProvider";

export const useBarcodeMovementsProps = () => {
  const { dictionary } = useAppContext();

  return {
    banner: {
      enabled: false,
    },
    actionBar: { enabled: false },
    pagination: { enabled: false },
    title: <h3>{dictionary.notifications.event_list}</h3>,
    selectRowsEnabled: { enabled: false },
  };
};
